/* @flow */
import React, { Component } from 'react'

import EmailFormContainer from '../../../EmailFormContainer/EmailFormContainer'
import VideoPlayer from '../../../Widgets/VideoPlayer/VideoPlayer';

import './HomeBanner.css'
import StarBackground from './StarBackground/StarBackground'

import globeBlank from '../../../../images/globe_blank.png'
import globeAnimation from '../../../../images/novo_globe_animation.gif'
import globeAnimationVideo from '../../../../images/novo_globe_animation.mp4'

type State = {
  videoOpen: boolean,
}

export default class HomeBanner extends Component<{}, State> {
  state = {
    videoOpen: window.location.search.substr(1).includes('playVideo=true'),
  }

  openVideo = () => {
    this.setState({ videoOpen: true });
  }

  closeVideo = () => {
    this.setState({ videoOpen: false });
  }

  render() {
    const { videoOpen } = this.state;

    return (
      <div className='HomeBanner'>
        <StarBackground />
        <div className="HomeBanner--content container">
          <h1 className="HomeBanner--title">UNIFYING THE WORLD’S BUSINESS DATA</h1>
          <p className="HomeBanner--subtitle">A blockchain-based marketplace for commercial data</p>
          <div className="HomeBanner--action-container inverse">
            <EmailFormContainer/>
            <div className="HomeBanner--secondary-action">
              Want to learn more?
              <a onClick={this.openVideo} >
                <i className="icon icon-play-circle-outline" /> Watch the video
              </a>
            </div>
          </div>
          <a onClick={this.openVideo} className="HomeBanner--globe-container">
            <video poster={globeBlank} autoPlay="autoplay" loop="loop" playbackRate="5" className="data-globe" >
              <source src={globeAnimationVideo} type="video/mp4" />
              <img src={globeAnimation} />
            </video>
            <i className="icon icon-play-circle HomeBanner--globe-play" />
          </a>
          <VideoPlayer videoId='r7rp13xf8o' isOpen={videoOpen} closeVideo={this.closeVideo} />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/Page/Home/HomeBanner/HomeBanner.js